'use strict';

var CssJs = require("bs-css-emotion/lib/js/src/CssJs.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");

var spin = CssJs.keyframes([
      [
        0,
        [CssJs.transform(CssJs.rotate(CssJs.deg(0)))]
      ],
      [
        100,
        [CssJs.transform(CssJs.rotate(CssJs.turn(1)))]
      ]
    ]);

function loadingContainer(takeFullHeight, containerWidth) {
  return CssJs.style([
              CssJs.display("flex"),
              CssJs.flexDirection(CssJs.column),
              CssJs.width(containerWidth),
              takeFullHeight ? CssJs.height({
                      NAME: "percent",
                      VAL: 100
                    }) : CssJs.empty([]),
              CssJs.alignItems(CssJs.center),
              CssJs.justifyContent(CssJs.center)
            ]);
}

function loading(size) {
  return CssJs.style([
              CssJs.backgroundColor(CssJs.transparent),
              CssJs.borderTopColor(CssJs.rgb(0, 133, 227)),
              CssJs.borderRightColor(CssJs.rgb(29, 92, 208)),
              CssJs.borderBottomColor(CssJs.rgb(29, 92, 208)),
              CssJs.borderLeftColor(CssJs.rgb(29, 92, 208)),
              CssJs.borderStyle(CssJs.solid),
              CssJs.borderWidth(CssJs.px(5)),
              CssJs.borderRadius(CssJs.px(50)),
              CssJs.width(CssJs.px(size)),
              CssJs.height(CssJs.px(size)),
              CssJs.zIndex(10),
              CssJs.animation(700, undefined, undefined, CssJs.linear, undefined, undefined, CssJs.infinite, spin)
            ]);
}

var loadingLabel = CssJs.style([CssJs.color(Theme$PvpcontrollerWeb.textColor)]);

function Loading(Props) {
  var style = Props.style;
  var label = Props.label;
  var takeFullHeightOpt = Props.takeFullHeight;
  var sizeOpt = Props.size;
  var containerWidthOpt = Props.containerWidth;
  var classNameOpt = Props.className;
  var takeFullHeight = takeFullHeightOpt !== undefined ? takeFullHeightOpt : false;
  var size = sizeOpt !== undefined ? sizeOpt : 50;
  var containerWidth = containerWidthOpt !== undefined ? containerWidthOpt : ({
        NAME: "percent",
        VAL: 100
      });
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var tmp = {
    className: loading(size)
  };
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  return React.createElement("div", {
              className: CssJs.merge([
                    loadingContainer(takeFullHeight, containerWidth),
                    className
                  ])
            }, React.createElement("div", tmp), label !== undefined ? React.createElement("div", {
                    className: loadingLabel
                  }, label) : React.createElement(React.Fragment, undefined));
}

function makeProps(prim0, prim1, prim2, prim3, prim4, prim5, prim6, prim7) {
  var tmp = {};
  if (prim0 !== undefined) {
    tmp.style = Caml_option.valFromOption(prim0);
  }
  if (prim1 !== undefined) {
    tmp.label = Caml_option.valFromOption(prim1);
  }
  if (prim2 !== undefined) {
    tmp.takeFullHeight = Caml_option.valFromOption(prim2);
  }
  if (prim3 !== undefined) {
    tmp.size = Caml_option.valFromOption(prim3);
  }
  if (prim4 !== undefined) {
    tmp.containerWidth = Caml_option.valFromOption(prim4);
  }
  if (prim5 !== undefined) {
    tmp.className = Caml_option.valFromOption(prim5);
  }
  if (prim6 !== undefined) {
    tmp.key = prim6;
  }
  return tmp;
}

var make = Loading;

exports.makeProps = makeProps;
exports.make = make;
/* spin Not a pure module */
